export default "__VITE_ASSET__BbD1aArw__"